import { render, staticRenderFns } from "./ArchivePurchaseStockings.vue?vue&type=template&id=04bd132d&"
import script from "./ArchivePurchaseStockings.vue?vue&type=script&lang=js&"
export * from "./ArchivePurchaseStockings.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePurchaseStockings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePurchaseStockings.vue"
export default component.exports